import { render, staticRenderFns } from "./SubmitClaim.vue?vue&type=template&id=321e4e04&scoped=true&"
import script from "./SubmitClaim.vue?vue&type=script&lang=js&"
export * from "./SubmitClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321e4e04",
  null
  
)

export default component.exports